import { Button, Card, Checkbox, Col, Input, notification, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "../../../../../utils/tms-with-router/tms-with-router";
import "../../../../../assets/css/tms-darshanam/tms-d-inner-pages-and.scss";
import TmsPrasdamService from "../../../../../services/tms-prasadam.service";
import catchErrorFunction from "../../../../../utils/tms-catch-error/tms-catch-error";
import TmsImageUpload from "../../../../../components/tms-customs/tms-image-upload";
import { BaseContext } from "../../../../../contexts/BaseContext";

const TmsPrasadamInnerPagesAND = ({
  viewPrasadamData,
  editFlag,
  productId,
  setEditFlag,
  settmsModalVisible,
  router,
}) => {
  const { userDetails } = useContext(BaseContext);
  const { TextArea } = Input;
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [description, setdescription] = useState("");
  const [counterEnabled, setcounterEnabled] = useState();
  const [onlineEnabled, setonlineEnabled] = useState();
  const [price, setprice] = useState();
  const [fileList, setFileList] = useState([]);
  const [max, setMax] = useState("");
  const [changeRequestFile, setChangeRequestFile] = useState([]);
  const [changeRequestDesc, setChangeRequestDesc] = useState("");

  const fetchData = async () => {
    setLoading(true);
    if (
      name === "" ||
      description === "" ||
      counterEnabled === "" ||
      onlineEnabled === "" ||
      fileList?.length === 0 ||
      price === "" ||
      max === ""
    ) {
      notification.error({ message: "Please enter all the details" });
      setLoading(false);
      return;
    }
    if (editFlag) {
      if (changeRequestFile?.length === 0 || changeRequestDesc === "") {
        notification.error({ message: "Please enter all the details" });
        setLoading(false);

        return;
      }
    }
    let body = {
      maxItemsPerOrder: max,
      name: name,
      description: description,
      counterEnabled: counterEnabled,
      onlineEnabled: onlineEnabled,
      price: price,
      imageUrl: fileList[0].url,
    };
    if (editFlag) {
      body.changeRequestPdfUrl = changeRequestFile[0].url;
      body.changeDescription = changeRequestDesc;
    }
    try {
      if (editFlag) {
        await TmsPrasdamService.editPrasadam(productId, body);
        // setDarshanamData(darData);
        notification.success({ message: "Prasadam Edited Successful" });
        setEditFlag(false);
      } else {
        await TmsPrasdamService.createPrasadam(body);
        // setDarshanamData(data?.items);
        notification.success({ message: "Prasadam Created Successful" });
        handleFuction();
      }
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
    setLoading(false);
  };

  const handleFuction = () => {
    setName("");
    setdescription("");
    setcounterEnabled(false);
    setonlineEnabled(false);
    setprice();
    setFileList([]);
    setChangeRequestFile([]);
    setChangeRequestDesc("");
  };

  useEffect(() => {
    if (editFlag) {
      setMax(viewPrasadamData?.maxItemsPerOrder);
      setName(viewPrasadamData?.name);
      setdescription(viewPrasadamData?.description);
      setcounterEnabled(viewPrasadamData?.counterEnabled);
      setonlineEnabled(viewPrasadamData?.onlineEnabled);
      setprice(viewPrasadamData?.price);
      setFileList([{ url: viewPrasadamData?.imageUrl, status: "done" }]);
    }
  }, [viewPrasadamData]);

  return (
    <Row className="formRow" style={{ width: "100%" }}>
      <Card style={{ width: "100%" }}>
        {/* <Row style={{ marginBottom: "10px" }}>
          <label className="formLabel">Seva Type</label>

          <Select
            className="formInput"
            onChange={(e) => {
              setSevaType(e);
            }}
            value={sevaType}
            defaultValue={sevaType}
          >
            <Select.Option value="parokshaSeva">Paroksha Seva</Select.Option>
            <Select.Option value="pratyakshaSeva">
              Pratyaksha Seva
            </Select.Option>
            <Select.Option value="All">Saswatha Seva</Select.Option>
          </Select>
        </Row> */}
        <Row className="formRow">
          <label className="formLabel">Prasadam Name</label>
          <Input
            className="formInput"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Row>
        <Row className="formRow">
          <label className="formLabel">Image Url</label>
          <TmsImageUpload fileList={fileList} setFileList={setFileList} />
        </Row>
        <Row className="formRow">
          <label className="formLabel">Description</label>
          <TextArea
            className="formInput"
            rows={4}
            value={description}
            onChange={(e) => setdescription(e.target.value)}
          />
        </Row>
        <Row className="formRow">
          <label className="formLabel">Max Bookings Per Order</label>
          <Input
            className="formInput"
            type="number"
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
            onWheel={(event) => event.currentTarget.blur()}
            value={max}
            onChange={(e) => setMax(Number(e.target.value))}
          />
        </Row>
        <Row gutter={[20, 20]} className="formRow">
          <label className="formLabel">Price</label>
          <Col className="formCols-2" style={{ padding: "0px 6px" }}>
            <Input
              type="number"
              onKeyDown={(e) =>
                ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
              }
              onWheel={(event) => event.currentTarget.blur()}
              value={price}
              onChange={(e) => setprice(Number(e.target.value))}
            />
          </Col>
          <Col className="formCols-2 contantCenter">
            <label style={{ paddingRight: "10px" }}>Enable POS</label>
            <Checkbox
              style={{ paddingRight: "10px" }}
              checked={counterEnabled}
              onChange={(e) => setcounterEnabled(e.target.checked)}
            />
            <label style={{ paddingRight: "10px" }}>Enable Online</label>
            <Checkbox
              checked={onlineEnabled}
              onChange={(e) => setonlineEnabled(e.target.checked)}
            />
          </Col>
        </Row>
        {editFlag && (
          <>
            <Row gutter={[20, 20]} className="formRow">
              <label className="formLabel">Request Copy</label>
              <Col className="formInput ">
                <TmsImageUpload
                  fileList={changeRequestFile}
                  setFileList={setChangeRequestFile}
                  router={router}
                  type="private"
                  accept={true}
                  className="w-100"
                />
              </Col>
            </Row>
            <Row className="formRow">
              <label className="formLabel">Edit Description</label>
              <Input
                className="formInput"
                value={changeRequestDesc}
                onChange={(e) => setChangeRequestDesc(e.target.value)}
              />
            </Row>
          </>
        )}
        <Row gutter={[20, 20]}>
          <Col span={5}></Col>
          <Col className="formCols-2 buttonPad">
            <Button
              className="formButton"
              type="primary"
              ghost
              loading={loading}
              onClick={() => {
                editFlag ? settmsModalVisible(false) : handleFuction();
              }}
            >
              {editFlag ? "Return" : "Clear"}
            </Button>
          </Col>
          <Col className="formCols-2 buttonPad">
            <Button
              className="formButton"
              type="primary"
              loading={loading}
              onClick={() => {
                fetchData();
              }}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Card>
    </Row>
  );
};

export default withRouter(TmsPrasadamInnerPagesAND);
